import { SingleBreakdownOptionMixin } from '../mixin';
import breakdownTranslatorMixin from '@/mixins/translator/breakdown';

import Chip from '../../components/Chip';

import * as C from '../../options/styles';

import BreakdownIcon from '@svgIcons/dashboard/breakdown.svg';

import { isValueExist } from '@/utils/utils';
import { IFRAME_EVENT_MESSAGE } from '@consts';
import { makeBreakdownFormat } from '../utils';

export default {
    name: 'SingleBreakdownOption',
    mixins: [SingleBreakdownOptionMixin, breakdownTranslatorMixin],
    props: {
        panelKey: String,
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomBreakdown: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            iframeListeners_: [
                {
                    eventType: IFRAME_EVENT_MESSAGE.UPDATE_BREAKDOWN_PANEL,
                    listener: (e) => {
                        const { data } = e;
                        if (!data || data.panelKey !== this.panelKey) return;
                        const { selectedFields } = data;

                        const updated = R.compose(
                            R.map(makeBreakdownFormat),
                            R.slice(0, 1)
                        )(selectedFields);
                        this.$emit('update', updated);
                    },
                },
            ],
        };
    },
    computed: {
        title() {
            return this.$t('FIELD_PANEL.breakdown.second_panel_title');
        },
        mainGuide() {
            return this.$t('FIELD_PANEL.breakdown.second_panel_main_guide');
        },
        subGuide() {
            return this.$t('FIELD_PANEL.breakdown.second_panel_sub_guide');
        },
        currentItem: R.compose(R.head, R.prop('currentList')),
    },
    methods: {
        renderItem() {
            const { currentItem } = this;

            if (!isValueExist(currentItem)) {
                return (
                    <C.ItemWrapper>
                        {this.renderNoList(
                            this.$t('EDITABLE_DASHBOARD.list_empty_breakdown')
                        )}
                    </C.ItemWrapper>
                );
            }

            const displayName =
                this.getFieldName(currentItem) ??
                this.getBreakdownName(currentItem);
            const status = this.getFieldStatus(currentItem);
            const isInvalid = status === C.ITEM_STATUS.INVALID;

            return (
                <C.ItemWrapper>
                    {this.wrapTooltip({
                        visible: isInvalid,
                        title: this.$t(
                            'EDITABLE_DASHBOARD.breakdown_no_longer_valid'
                        ),
                        content: (
                            <Chip
                                title={displayName}
                                status={status}
                                loading={this.fieldLabelsLoading}
                            />
                        ),
                    })}
                </C.ItemWrapper>
            );
        },
    },
    render() {
        const { wrapOptions, renderItem } = this;

        return (
            <C.ComponentWrapper>
                {wrapOptions({
                    children: renderItem(),
                    title: this.$t(
                        'NEW_DASHBOARD.row_modal_order_row_title_single'
                    ),
                    icon: <BreakdownIcon class="metric-icon" />,
                    loading: this.fieldLabelsLoading,
                })}
            </C.ComponentWrapper>
        );
    },
};
